import React from 'react';
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
  Font,
} from '@react-pdf/renderer';
import logoImg from '../../assets/images/ahedge_blue_logo.png';

// Register Roboto font
Font.register({
  family: 'Roboto',
  fonts: [
    {
      src: 'https://cdnjs.cloudflare.com/ajax/libs/ink/3.1.10/fonts/Roboto/roboto-regular-webfont.ttf',
    },
    {
      src: 'https://cdnjs.cloudflare.com/ajax/libs/ink/3.1.10/fonts/Roboto/roboto-medium-webfont.ttf',
      fontWeight: 500,
    },
    {
      src: 'https://cdnjs.cloudflare.com/ajax/libs/ink/3.1.10/fonts/Roboto/roboto-bold-webfont.ttf',
      fontWeight: 700,
    },
  ],
});

const styles = StyleSheet.create({
  page: {
    fontFamily: 'Roboto',
    color: '#333',
    padding: 40,
    position: 'relative',
  },
  container: {
    flex: 1,
    padding: 15,
    position: 'relative',
    zIndex: 1,
    display: 'flex',
    flexDirection: 'column',
  },
  contentContainer: {
    flex: 1,
  },
  watermark: {
    position: 'absolute',
    top: '30%',
    left: '25%',
    right: '25%',
    transform: 'translate(-50%, -50%)',
    opacity: 0.05,
    width: '55%',
    height: '55%',
    zIndex: 0,
  },
  watermarkImage: {
    width: '100%',
    height: '100%',
    objectFit: 'contain',
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    borderBottom: '1 solid #eee',
    paddingBottom: 10,
    marginBottom: 15,
    position: 'relative',
    zIndex: 1,
  },
  creditNoteInfo: {
    flex: 1,
  },
  creditNoteTitle: {
    fontSize: 22,
    fontWeight: 700,
    color: '#333',
    marginBottom: 6,
  },
  creditNoteNumber: {
    fontSize: 14,
    fontWeight: 500,
    color: '#555',
    marginBottom: 4,
  },
  creditNoteDate: {
    fontSize: 12,
    color: '#555',
    marginBottom: 2,
  },
  poNumber: {
    fontSize: 12,
    color: '#555',
    marginBottom: 5,
  },
  logo: {
    width: 120,
    height: 'auto',
    marginBottom: 8,
  },
  statusBadge: {
    marginTop: 5,
    fontSize: 11,
    fontWeight: 500,
    color: '#fff',
    backgroundColor: '#145EA9',
    padding: '4 8',
    borderRadius: 4,
    alignSelf: 'flex-start',
  },
  section: {
    marginBottom: 20,
  },
  sectionTitle: {
    fontSize: 14,
    color: '#145EA9',
    borderBottom: '2 solid #145EA9',
    paddingBottom: 5,
    marginBottom: 12,
    fontWeight: 500,
  },
  addressContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 20,
  },
  addressBox: {
    width: '48%',
  },
  addressHeading: {
    fontSize: 12,
    fontWeight: 500,
    color: '#555',
    marginBottom: 5,
  },
  companyName: {
    fontSize: 12,
    fontWeight: 700,
    color: '#333',
    marginBottom: 4,
  },
  addressLine: {
    fontSize: 11,
    color: '#555',
    marginBottom: 2,
  },
  gstinLine: {
    fontSize: 11,
    fontWeight: 500,
    color: '#555',
    marginTop: 4,
  },
  creditNoteDetails: {
    backgroundColor: '#f8fafc',
    border: '1 solid #e2e8f0',
    borderRadius: 4,
    padding: 12,
    marginBottom: 20,
  },
  detailRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 6,
  },
  detailLabel: {
    fontSize: 11,
    fontWeight: 500,
    color: '#475569',
  },
  detailValue: {
    fontSize: 11,
    color: '#1e293b',
    fontWeight: 600,
  },
  table: {
    width: '100%',
    marginVertical: 8,
  },
  tableHeader: {
    flexDirection: 'row',
    backgroundColor: '#f9fafb',
    padding: '10 5',
    borderBottom: '1 solid #e5e7eb',
  },
  tableRow: {
    flexDirection: 'row',
    borderBottom: '1 solid #e5e7eb',
    padding: '10 5',
    minHeight: 35,
    alignItems: 'center',
  },
  candidateCell: {
    flex: 2,
    paddingRight: 8,
  },
  requirementCell: {
    flex: 2,
    paddingRight: 8,
  },
  poCell: {
    flex: 1,
    paddingRight: 8,
  },
  amountCell: {
    flex: 1,
    textAlign: 'right',
    paddingRight: 5,
  },
  headerText: {
    fontSize: 10,
    color: '#6b7280',
    fontWeight: 500,
  },
  cellText: {
    fontSize: 10,
    color: '#374151',
  },
  summaryRow: {
    flexDirection: 'row',
    padding: '10 5',
    minHeight: 35,
    alignItems: 'center',
  },
  summaryLabelCell: {
    flex: 7,
    textAlign: 'right',
    paddingRight: 10,
    fontWeight: 500,
    fontSize: 11,
    color: '#555',
  },
  summaryValueCell: {
    flex: 2,
    textAlign: 'right',
    fontSize: 11,
    color: '#374151',
  },
  grandTotalRow: {
    flexDirection: 'row',
    padding: '10 5',
    minHeight: 35,
    alignItems: 'center',
    backgroundColor: '#f9fafb',
  },
  grandTotalLabel: {
    flex: 7,
    textAlign: 'right',
    paddingRight: 10,
    fontWeight: 700,
    fontSize: 12,
    color: '#333',
  },
  grandTotalValue: {
    flex: 2,
    textAlign: 'right',
    fontWeight: 700,
    fontSize: 12,
    color: '#333',
  },
  balanceSection: {
    backgroundColor: '#fef2f2',
    border: '1 solid #fecaca',
    borderRadius: 4,
    padding: 12,
    marginTop: 15,
  },
  balanceTitle: {
    fontSize: 12,
    fontWeight: 600,
    color: '#dc2626',
    marginBottom: 8,
  },
  balanceRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 4,
  },
  balanceLabel: {
    fontSize: 11,
    color: '#7f1d1d',
  },
  balanceValue: {
    fontSize: 11,
    fontWeight: 600,
    color: '#dc2626',
  },
  footer: {
    borderTop: '1 solid #eee',
    paddingTop: 10,
    fontSize: 9,
    color: '#6b7280',
    textAlign: 'center',
    marginTop: 'auto',
  },
});

// Helper function to determine status badge color
const getStatusStyle = (status) => {
  switch (status?.toUpperCase()) {
    case 'PAID':
      return { backgroundColor: '#22c55e' };
    case 'SENT':
      return { backgroundColor: '#2168B2' };
    case 'OVERDUE':
      return { backgroundColor: '#ef4444' };
    case 'DRAFT':
      return { backgroundColor: '#94a3b8' };
    default:
      return { backgroundColor: '#145EA9' };
  }
};

// Reusable Page component with footer at the bottom
const PageWithFooter = ({ children }) => (
  <Page size="A4" style={styles.page}>
    <View style={styles.watermark}>
      <Image src={logoImg} style={styles.watermarkImage} />
    </View>
    <View style={styles.container}>
      <View style={styles.contentContainer}>{children}</View>
      <View style={styles.footer}>
        <Text>
          This is a system-generated credit note. No signature required.
        </Text>
      </View>
    </View>
  </Page>
);

const CreditNotesPDF = ({ data }) => {
  // Extract data for easy access
  const {
    creditNoteNumber,
    creditNoteDate,
    poNumber,
    client,
    ahedge,
    creditNoteDetails,
    candidateDetails,
  } = data;

  const statusStyle = getStatusStyle(creditNoteDetails?.status);

  return (
    <Document>
      {/* First page - Main content */}
      <PageWithFooter>
        {/* Header Section */}
        <View style={styles.header}>
          <View style={styles.creditNoteInfo}>
            <Image src={logoImg} style={styles.logo} />
            <Text style={styles.creditNoteTitle}>CREDIT NOTE</Text>
            <Text style={styles.creditNoteNumber}>
              Credit Note Number: {creditNoteNumber}
            </Text>
            <Text style={styles.creditNoteDate}>
              Issue Date: {creditNoteDate}
            </Text>
            <Text style={styles.poNumber}>PO Number: {poNumber}</Text>
            <View style={[styles.statusBadge, statusStyle]}>
              <Text style={{ color: '#fff', fontSize: 10 }}>
                {creditNoteDetails?.status}
              </Text>
            </View>
          </View>
        </View>

        {/* Address Section */}
        <View style={styles.addressContainer}>
          {/* From Address */}
          <View style={styles.addressBox}>
            <Text style={styles.addressHeading}>From:</Text>
            <Text style={styles.companyName}>{ahedge.name}</Text>
            <Text style={styles.addressLine}>{ahedge.address}</Text>
            <Text style={styles.addressLine}>{ahedge.cityStatePin}</Text>
            <Text style={styles.gstinLine}>GSTIN: {ahedge.gstin}</Text>
          </View>

          {/* To Address */}
          <View style={styles.addressBox}>
            <Text style={styles.addressHeading}>To:</Text>
            <Text style={styles.companyName}>{client.name}</Text>
            {client.address && (
              <>
                {client.address.line1 && (
                  <Text style={styles.addressLine}>{client.address.line1}</Text>
                )}
                {client.address.street && (
                  <Text style={styles.addressLine}>
                    {client.address.street}
                  </Text>
                )}
                {client.address.zipCode && (
                  <Text style={styles.addressLine}>
                    {client.address.zipCode}
                  </Text>
                )}
              </>
            )}
            {client.gstin && client.gstin !== 'N/A' && (
              <Text style={styles.gstinLine}>GSTIN: {client.gstin}</Text>
            )}
          </View>
        </View>

        {/* Credit Note Details Section */}
        <View style={styles.section}>
          <Text style={styles.sectionTitle}>Credit Note Details</Text>
          <View style={styles.creditNoteDetails}>
            <View style={styles.detailRow}>
              <Text style={styles.detailLabel}>Credit Note Type:</Text>
              <Text style={styles.detailValue}>
                {creditNoteDetails.creditNoteType}
              </Text>
            </View>
            <View style={styles.detailRow}>
              <Text style={styles.detailLabel}>Sub Total:</Text>
              <Text style={styles.detailValue}>
                {creditNoteDetails.subTotal?.toLocaleString()}
              </Text>
            </View>
            <View style={styles.detailRow}>
              <Text style={styles.detailLabel}>
                Tax ({creditNoteDetails.taxPercentage}%):
              </Text>
              <Text style={styles.detailValue}>
                {creditNoteDetails.taxAmount?.toLocaleString()}
              </Text>
            </View>
            <View style={styles.detailRow}>
              <Text style={styles.detailLabel}>Total Amount:</Text>
              <Text style={styles.detailValue}>
                {creditNoteDetails.totalAmount?.toLocaleString()}
              </Text>
            </View>
          </View>
        </View>

        {/* Candidate Details Section */}
        {candidateDetails && (
          <View style={styles.section} wrap={false}>
            <Text style={styles.sectionTitle}>Candidate Details</Text>
            <View style={styles.table}>
              <View style={styles.tableHeader}>
                <Text style={[styles.headerText, styles.candidateCell]}>
                  Candidate Name
                </Text>
                <Text style={[styles.headerText, styles.requirementCell]}>
                  Requirement
                </Text>
                <Text style={[styles.headerText, styles.poCell]}>
                  PO Number
                </Text>
                <Text style={[styles.headerText, styles.amountCell]}>
                  Amount
                </Text>
              </View>
              <View style={styles.tableRow}>
                <Text style={[styles.cellText, styles.candidateCell]}>
                  {candidateDetails.candidate_name || 'N/A'}
                </Text>
                <Text style={[styles.cellText, styles.requirementCell]}>
                  {candidateDetails.requirement_title || 'N/A'}
                </Text>
                <Text style={[styles.cellText, styles.poCell]}>{poNumber}</Text>
                <Text style={[styles.cellText, styles.amountCell]}>
                  {creditNoteDetails.totalAmount?.toLocaleString()}
                </Text>
              </View>
            </View>
          </View>
        )}

        {/* Balance Section */}
        <View style={styles.balanceSection}>
          <Text style={styles.balanceTitle}>Payment Summary</Text>
          <View style={styles.balanceRow}>
            <Text style={styles.balanceLabel}>Total Paid:</Text>
            <Text style={styles.balanceValue}>
              {creditNoteDetails.totalPaid?.toLocaleString()}
            </Text>
          </View>
          <View style={styles.balanceRow}>
            <Text style={styles.balanceLabel}>Balance Due:</Text>
            <Text style={styles.balanceValue}>
              {creditNoteDetails.balanceDue?.toLocaleString()}
            </Text>
          </View>
        </View>
      </PageWithFooter>
    </Document>
  );
};

export default CreditNotesPDF;
